module.exports = __webpack_public_path__ + "media/images/features/excellent_support_img-8d81b7e95acc9d7aedb1b654d2eb727b.png";